import {useNavigate, useParams} from "react-router-dom";
import React, {useState} from "react";

import './style.scss'
import Footer from "../../ui/Footer";
import {useTranslation} from "react-i18next";
import Header from "../../ui/Header";
import Button from "../../ui/Button";


function Subscriptions({wasSearched}) {
  let { bulletinId } = useParams();
  let navigate = useNavigate()
  let { t } = useTranslation();

  let [sent, setSent] = useState(false)

  const handleSend = ({name, email, question}) => {
    console.log('[{name, email, question}]', {name, email, question})
    setSent(true)
  }

  return (
    <div className="dsearch-api-page">

      <Header/>

      <div className="dsearch-api-page__body" >
        <h2>Подписка на новые уязвимости и эксплойты</h2>
        <br/>

        <p>
          D-search позволяет получать уведомления о новых уязвимостях и эксплойтах для интересующих вас систем и программном обеспечении.
          Подпишите свою команду безопасности и администраторов системы на мгновенное получение подробной информации.
        </p>

        <p>
          Стоимость подписки формируется в зависимости от количества API обращений в месяц.
        </p>

        <br/>

        <table>
          <th>
            <td>API кредиты</td>
            <td>Цена по кредитам</td>
          </th>
          <tr>
            <td>500 Кредитов</td>
            <td>150 ₽</td>
          </tr>
          <tr>
            <td>Свыше 500 Кредитов</td>
            <td>По запросу</td>
          </tr>
        </table>

        <Button onClick={() => navigate('/contacts')}>Подписаться</Button>
      </div>

      <Footer/>

    </div>
  );
}

export default Subscriptions;
